var React = require('react');

function NavIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"NavIcon"},React.createElement("g",{"id":"Group 37"},[React.createElement("rect",{"id":"Rectangle 3","x":"34.3651","y":"2","width":"5.07303","height":"32.1292","rx":"2.53652","fill":"white","key":0}),React.createElement("rect",{"id":"Rectangle 4","x":"20.837","y":"18.9101","width":"5.07303","height":"27.0562","rx":"2.53652","fill":"white","key":1}),React.createElement("rect",{"id":"Rectangle 5","x":"9","y":"13.8371","width":"5.07303","height":"18.6011","rx":"2.53652","fill":"white","key":2})])));
}

NavIcon.defaultProps = {"width":"49","height":"49","viewBox":"0 0 49 49","fill":"none"};

module.exports = NavIcon;

NavIcon.default = NavIcon;
